import React from 'react';
import PropTypes from 'prop-types';
import { I18n, Translate } from 'react-redux-i18n';
import moment from 'moment';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const ProjectSummaryView = props => {
  const getInviteeRow = invitee => /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "card-header font-size-m pb-3",
      children: /*#__PURE__*/_jsx(Translate, {
        value: `project.invite.${invitee.role}.invitedNotice`,
        dangerousHTML: true
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "information",
      children: [/*#__PURE__*/_jsxs("div", {
        children: [invitee.fullName || invitee.organisationName, /*#__PURE__*/_jsx("strong", {
          children: ` (${invitee.registrationNumber})`
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "pt-3",
        children: invitee.user?.email || invitee?.email
      })]
    })]
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "box border bottom",
      children: /*#__PURE__*/_jsxs("div", {
        className: "inline-container col-12",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "col-3",
          children: [/*#__PURE__*/_jsx("div", {
            className: "card-header font-size-m",
            children: /*#__PURE__*/_jsx(Translate, {
              value: "project.details.name"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "information",
            children: props.projectDetails?.name
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "col-3",
          children: [/*#__PURE__*/_jsx("div", {
            className: "card-header font-size-m",
            children: /*#__PURE__*/_jsx(Translate, {
              value: "address.addressLine"
            })
          }), /*#__PURE__*/_jsxs("div", {
            className: "information",
            children: [`${props.projectDetails?.address.addressLine},`, /*#__PURE__*/_jsx("br", {}), `${props.projectDetails?.address.postCode} ${props.projectDetails?.address.city}`]
          })]
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "box border bottom",
      children: /*#__PURE__*/_jsxs("div", {
        className: "inline-container col-12",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "col-3",
          children: [/*#__PURE__*/_jsx("div", {
            className: "card-header font-size-m",
            children: /*#__PURE__*/_jsx(Translate, {
              value: "project.details.openingDate"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "information",
            children: moment(props.projectDetails?.openingDate).format('DD/MM/YYYY')
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "col-3",
          children: [/*#__PURE__*/_jsx("div", {
            className: "card-header font-size-m",
            children: /*#__PURE__*/_jsx(Translate, {
              value: "project.details.closingDate"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "information",
            children: moment(props.projectDetails?.closingDate).format('DD/MM/YYYY')
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "col-6 pl-4",
          children: [/*#__PURE__*/_jsx("div", {
            className: "card-header font-size-m",
            children: /*#__PURE__*/_jsx(Translate, {
              value: "project.role.chosenRole"
            })
          }), /*#__PURE__*/_jsx("strong", {
            children: I18n.t(`project.role.${props.projectRole}.title`)
          })]
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "box border bottom",
      children: /*#__PURE__*/_jsxs("div", {
        className: "inline-container col-12",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "col-6",
          children: [/*#__PURE__*/_jsx("div", {
            className: "card-header font-size-m",
            children: /*#__PURE__*/_jsx(Translate, {
              value: "project.documents.requiredDocuments"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "information",
            children: /*#__PURE__*/_jsx("ul", {
              children: props.projectDocuments?.map((document, index) => /*#__PURE__*/_jsx("li", {
                className: "mb-2",
                children: document.label
              }, index))
            })
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "col-6",
          children: props.participants.map((participant, index) => {
            let className = 'box border bottom pb-5';
            if (index === props.participants.length - 1) {
              className = 'box border pb-5';
            }
            return /*#__PURE__*/_jsx("div", {
              className: className,
              children: getInviteeRow(participant)
            }, index);
          })
        })]
      })
    })]
  });
};
ProjectSummaryView.defaultProps = {
  participants: []
};
ProjectSummaryView.propTypes = {
  projectDetails: PropTypes.object,
  projectDocuments: PropTypes.array,
  projectRole: PropTypes.string,
  participants: PropTypes.array.isRequired
};
export default ProjectSummaryView;